import { render, staticRenderFns } from "./AuditLogTable.vue?vue&type=template&id=4977167a&"
import script from "./AuditLogTable.vue?vue&type=script&lang=js&"
export * from "./AuditLogTable.vue?vue&type=script&lang=js&"
import style0 from "./AuditLogTable.vue?vue&type=style&index=0&id=4977167a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports